import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';
import DailyWorkOrdersModal from './DailyWorkOrdersModal';

const RevenueTrendChart = ({ data = [], loading = false }) => {
  const [selectedDate, setSelectedDate] = useState(null);

  const formatCurrency = (value) => {
    return `$${value?.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date?.toLocaleDateString('es-MX', { day: '2-digit', month: 'short' });
  };

  const handleDotClick = (data) => {
    if (data && data?.date) {
      setSelectedDate(data?.date);
    }
  };

  return (
    <>
      <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
        <div className="flex items-center justify-between mb-4 md:mb-6">
          <div className="flex items-center gap-2">
            <Icon name="TrendingUp" size={24} className="text-success" />
            <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
              Tendencia de Ingresos Diarios
            </h2>
          </div>
          <p className="text-xs text-muted-foreground">
            Click en los puntos para ver órdenes del día
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center items-center h-64">
            <Icon name="Loader2" className="w-8 h-8 text-blue-600 animate-spin" />
          </div>
        ) : data?.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-64">
            <Icon name="BarChart3" size={48} className="text-muted-foreground mb-2" />
            <p className="text-sm caption text-muted-foreground">
              No hay datos de tendencia disponibles
            </p>
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
              <XAxis 
                dataKey="date" 
                tickFormatter={formatDate}
                stroke="#6b7280"
                style={{ fontSize: '12px' }}
              />
              <YAxis 
                tickFormatter={formatCurrency}
                stroke="#6b7280"
                style={{ fontSize: '12px' }}
              />
              <Tooltip 
                formatter={(value) => [formatCurrency(value), 'Ingresos']}
                labelFormatter={formatDate}
                contentStyle={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px',
                  padding: '8px 12px'
                }}
              />
              <Line 
                type="monotone" 
                dataKey="revenue" 
                stroke="#10b981" 
                strokeWidth={2}
                dot={{ fill: '#10b981', r: 4 }}
                activeDot={{ r: 6, cursor: 'pointer', onClick: handleDotClick }}
              />
            </LineChart>
          </ResponsiveContainer>
        )}
      </div>

      {selectedDate && (
        <DailyWorkOrdersModal
          date={selectedDate}
          onClose={() => setSelectedDate(null)}
        />
      )}
    </>
  );
};

export default RevenueTrendChart;